import React from 'react';
import {Field} from 'react-final-form';
import {TextInputSize} from '@yandex-data-ui/common';

import {parseBytes} from 'utils';
import {FormFieldRangeInputPicker} from 'components/formFields';
import {getMemSizeLabel} from 'components/calculator/MDBForm/utils';
import {DISK_SIZE_STEP} from 'components/calculator/MDBForm/constants';
import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';

interface SizeRangeInputProps extends WithTranslationProps {
    name: string;
    min: number;
    max: number;
    size: TextInputSize;
    readOnly?: boolean;
    onUpdate?: (value: number) => void;
}

const SizeRangeInput: React.FC<SizeRangeInputProps> = ({
    name,
    size,
    min,
    max,
    readOnly,
    onUpdate,
    i18n,
}) => (
    <Field name={name}>
        {(fieldProps) => (
            <FormFieldRangeInputPicker
                {...fieldProps}
                size={size}
                minValue={min}
                maxValue={max}
                step={DISK_SIZE_STEP}
                format={(value?: number) => getMemSizeLabel(value || 0, i18n)}
                parse={(str: string) => parseBytes(str, 'gb')}
                readOnly={readOnly}
                onUpdate={onUpdate}
            />
        )}
    </Field>
);

export default withTranslation()(SizeRangeInput);
